import React from 'react';

const FilterContext = React.createContext<string>(null);

export default FilterContext;